module.exports = __webpack_public_path__ + "img/permitirdispositivo.2b935de0.png";